<template>
  <div>
    <CRow class="mb-3 search-panel">
      <!--      <CCol xs="12" sm="1" md="1" lg="1" style="min-width: 105px; max-width: 120px;">-->
      <!--        <div class="dropdown btn-group" style="height: 36px;">-->
      <!--          <button class="btn">-->
      <!--            <div class="group-checkbox">-->
      <!--              <div class="custom-control custom-checkbox">-->
      <!--                <input-->
      <!--                  type="checkbox"-->
      <!--                  class="custom-control-input"-->
      <!--                  v-model="actionData.model.selectedAll"-->
      <!--                  @change="changeSelectAll"-->
      <!--                  id="selectedAll"-->
      <!--                />-->
      <!--                <label class="custom-control-label" for="selectedAll"></label>-->
      <!--              </div>-->
      <!--            </div>-->
      <!--          </button>-->
      <!--          <button-->
      <!--            type="button"-->
      <!--            class="dropdown-toggle dropdown-toggle-split btn"-->
      <!--            data-toggle="dropdown"-->
      <!--            aria-expanded="false"-->
      <!--            aria-haspopup="true"-->
      <!--          ></button>-->
      <!--          <div class="dropdown-menu">-->
      <!--            <button-->
      <!--              :disabled="actionData.model.listCategorySelected.length === 0"-->
      <!--              class="dropdown-item"-->
      <!--              @click="setupSelectOneAction('delete_list')"-->
      <!--              color="danger"-->
      <!--            >-->
      <!--              <CIcon name="cil-trash" style="danger" class="mr-2"/>-->
      <!--              Delete selected-->
      <!--            </button>-->
      <!--          </div>-->
      <!--        </div>-->
      <!--      </CCol>-->
      <CCol sm="12" xs="12" md="12" lg="12" xl="2">
        <BaseInput
          :options="codeInput.options"
          :data="codeInput.data"
          :listener="codeInput.listener"
        />
      </CCol>
      <CCol sm="12" xs="12" md="6" lg="6" xl="2">
        <BaseInput
          :options="nameInput.options"
          :data="nameInput.data"
          :listener="nameInput.listener"
        />
      </CCol>
      <CCol sm="12" xs="12" md="6" lg="6" xl="2">
        <BaseSelect
          :options="isActiveSelect.options"
          :data="isActiveSelect.data"
          ref="isActive"
        >
        </BaseSelect>
      </CCol>
      <CCol>
        <CButton
          style="float: right;margin-left: 5px;"
          color="primary"
          v-c-tooltip.hover="'Tìm kiếm'"
          class="btn-action-primary"
          @click="loadDataMainTable(true)">
          <i class="fa fa-search"></i>&nbsp;&nbsp; Tìm kiếm
        </CButton>
        <CButton
          style="float: right;"
          color="primary"
          v-c-tooltip.hover="'Thêm mới'"
          class="btn-action-primary"
          @click="$router.push('/slider-management/add')"
        >
          <i class="fa fa-plus"></i>&nbsp;&nbsp; Thêm mới
        </CButton>
      </CCol>
    </CRow>
    <CCard class="content-fade-in mt-3p5">
      <CCardBody>
        <BaseTable
          :options="mainTable.options"
          :slots="mainTable.slots"
          :dataSource="mainTable.dataSource"
          ref="mainTable"
        >
          <template #checkbox="{item}">
            <td class="group-checkbox">
              <div class="custom-control custom-checkbox">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  v-model="actionData.model.listCategorySelected"
                  :value="item.id"
                  :id="item.id"
                  v-c-tooltip.hover="'Selected'"
                />
                <label class="custom-control-label" :for="item.id"></label>
              </div>
            </td>
          </template>

          <template #stt="{index}">
            <td>{{ $refs.mainTable.getTotalElementByPage + index }}</td>
          </template>

          <template #filePath="{item}" >
            <td style="width: 15%;">
              <img :src="item.filePath" alt="" style="width: 150px">
            </td>
          </template>
          <template #active="{item}">
            <td>
              <span v-if="item.active == false" class="dot-custom dot-danger">Không hoạt động</span>
              <span v-else-if="item.active == true" class="dot-custom dot-success">Hoạt động</span>
            </td>
          </template>

          <template #nameParent="{item}">
            <td>
              <span v-if="item.nameParent == null || item.nameParent == ''" style="color: #0b816a;font-weight: 550">Danh mục gốc</span>
              <span v-else>{{ item.nameParent }}</span>
            </td>
          </template>

          <template #action="{item}">
            <td class="action-btn-group">
              <div class="action-btn-wrapper">
                <CButton color="info"
                         variant="outline"
                         v-c-tooltip.hover="'Cập nhật'"
                         square
                         size="sm"
                         @click="$router.push(`/slider-management/managed-slider/${item.id}`)">
                  <CIcon name="cil-pencil"/>
                </CButton>
                <CButton
                  color="danger"
                  variant="outline"
                  class="ml-1"
                  square
                  size="sm"
                  v-c-tooltip.hover="'Xóa'"
                  @click=" setupSelectOneAction('delete_one', item.id, item.name)">
                  <CIcon name="cil-trash"/>
                </CButton>
              </div>
            </td>
          </template>
        </BaseTable>
      </CCardBody>
    </CCard>
    <ModalConfirm
      :actionTypeMapping="actionData.actionTypeMapping"
      ref="actionModal"
    >
    </ModalConfirm>
  </div>
</template>

<script>
import BaseTable from "../base/BaseDataTable";
import ModalConfirm from "../base/BaseModalConfirm";
import BaseInput from "../base/BaseInput";
import BaseSelect from "../base/BaseSelect2";

export default {
  name: "SlideList",
  components: {BaseTable, ModalConfirm, BaseInput, BaseSelect},
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success"
    },
    showErrorMsg: {
      type: "error",
      title: "Error"
    },
    showWarningMsg: {
      type: "warn",
      title: "warn"
    }
  },
  data() {
    var that = this;
    var actionTypeMapping = new Map();
    actionTypeMapping.set("delete_one", {
      url: "/slide/deleteById",
      titlePopup: function () {
        return that.$helper.setupTitleAction(
          "xóa",
          "slide",
          that.actionData.model.slideSelectedName
        );
      },
      dataSubmit: function () {
        return {
          id: that.actionData.model.slideSelectedId
        };
      },
      successCallback: function () {
        that.actionData.model.listCategorySelected = [];
        that.showSuccessMsg({
          message: "Xóa slide thành công"
        });
        that.loadDataMainTable();
      },
      isJsonContentType: false
    });
    // actionTypeMapping.set("delete_list", {
    //   url: "/business/deleteByLsId",
    //   titlePopup: function () {
    //     return that.$helper.setupTitleAction("xóa", "các danh mục", "đã chọn");
    //   },
    //   dataSubmit: function () {
    //     return {
    //       lsId: that.actionData.model.listCategorySelected
    //     };
    //   },
    //   successCallback: function () {
    //     that.actionData.model.listCategorySelected = [];
    //     that.showSuccessMsg({
    //       message: "Xóa danh mục thành công"
    //     });
    //     that.loadDataMainTable();
    //   },
    //   isJsonContentType: false
    // });
    return {
      actionData: {
        actionTypeMapping: actionTypeMapping,
        model: {
          selectedAll: false,
          slideSelectedName: null,
          slideSelectedId: null,
          listCategorySelected: []
        }
      },
      codeInput: {
        options: {
          placeholder: "Mã Slider",
          label: 'Mã Slider'
        },
        data: {
          name: "code",
          model: "",
          updateTrigger: function () {
            return that.$refs.mainTable;
          }
        }
      },
      nameInput: {
        options: {
          placeholder: "Tên Slider",
          label: 'Tên Slider'
        },
        data: {
          name: "name",
          model: "",
          updateTrigger: function () {
            return that.$refs.mainTable;
          }
        }
      },
      isActiveSelect: {
        options: {
          filter: false,
          label: 'Trạng thái',
        },
        data: {
          name: "active",
          items: [
            {key: "null", value: "Tất cả trạng thái"},
            {key: "true", value: "Hoạt động"},
            {key: "false", value: "Không hoạt động"},
          ],
          model: 'null',
          updateTrigger: function () {
            return that.$refs.mainTable;
          }
        }
      },
      mainTable: {
        options: {
          noPaging: true,
          fields: [
            // {key: "checkbox", label: "#"},
            {key: "stt", label: "STT"},
            {key: "code", label: "Mã Slide"},
            {key: "name", label: "Tên Slide"},
            {key: "active", label: "Trạng thái"},
            {key: "fileName", label: "Tên file"},
            {key: "filePath", label: "Hình ảnh"},
            {key: "action", label: "Thao tác"}
          ],
          slots: ["checkbox", "stt", "active", "filePath", "action"],
          pageSize: 20
        },
        dataSource: {
          url: "/slide/listSlide",
          dataSubmit: function () {
            return that.$helper.setupDataSubmit(that.$data)
          },
          response: function (dataResponse) {
            return dataResponse.data;
          },
          resultListAttrName: "data"
        }
      }
    };
  },
  methods: {
    loadDataMainTable: function (isUpdateFilter) {
      this.$refs.mainTable.loadData(true, isUpdateFilter);
    },
    changeSelectAll: function (event) {
      if (this.actionData.model.selectedAll) {
        this.actionData.model.listCategorySelected = [];
        this.$refs.mainTable.items.forEach(each => {
          this.actionData.model.listCategorySelected.push(each.id);
        });
      } else {
        this.actionData.model.listCategorySelected = [];
      }
    },
    setupSelectOneAction: function (actionTypeKey, slideSelectedId, slideSelectedName ) {
      var actionData = this.actionData.model;
      actionData.slideSelectedName = slideSelectedName || null;
      actionData.slideSelectedId = slideSelectedId || null;
      this.$refs.actionModal.setCurrAction(actionTypeKey);
    },
    setupSelectMoreAction: function (actionTypeKey) {
      this.$refs.actionModal.setCurrAction(actionTypeKey);
    }
  },
  created: function () {
  },
  mounted() {
  },
  watch: {
    "actionData.model.listCategorySelected": function (newValue) {
      var that = this;
      if (newValue.length === that.$refs.mainTable.items.length) {
        that.actionData.model.selectedAll = true;
      } else {
        that.actionData.model.selectedAll = false;
      }
    }
  },
  computed: {}
};
</script>
<style scoped>
.td-roles {
  max-width: 250px;
}
</style>
